






















































































































export default
  name: 'Sidebar'
  data: ->
    return
      supply: [
        { name: 'Experiences', to: 'AudienceCreativeListPage' }
        { name: 'Venues', to: 'VenueListPage' }
        { name: 'Assets', to: 'SpaceListPage' }
        { name: 'Availabilities', to: 'AudienceAvailabilityListPage' }
        { name: 'Audience Listings', to: 'AudienceListingListPage' }
        { name: 'Events', to: 'EventListPage' }
        { name: 'Suppliers', to: 'SupplierListPage' }
        { name: 'Organizers', to: 'OrganizerListPage' }
        { name: 'Organizer Invitations', to: 'OrganizerInvitationListPage' }
        { name: 'Remittances', to: 'RemittanceListPage' }
        { name: 'Audience Partnerships', to: 'AudiencePartnershipListPage' }
        { name: 'Pro Services', to: 'VendorListingListPage' }
        { name: 'Recaps', to: 'RecapListPage' }
        { name: 'Availability Indicators', to: 'IndicatorsListPage' }
        { name: 'Payout Board', to: 'PayoutBoardOfferListPage' }
      ]
      buy: [
        { name: 'Offers', to: 'OfferListPage' }
        { name: 'Advertisers', to: 'SponsorListPage' }
        { name: 'Brands', to: 'BrandInfoListPage' }
        { name: 'Brand Reps', to: 'BrandRepListPage' }
        { name: 'Activations', to: 'ActivationListPage' }
        { name: 'Campaigns', to: 'CampaignListPage' }
        { name: 'Points of Interest', to: 'POIListPage' }
        { name: 'Brand Rep Invitations', to: 'BrandRepInvitationListPage' }
        { name: 'Shopping Carts', to: 'ShoppingCartListPage' }
        { name: 'Purchase Orders', to: 'PurchaseOrderListPage' }
        { name: 'Purchases', to: 'PurchaseListPage' }
        { name: 'Invoices', to: 'InvoiceListPage' }
        { name: 'Event Requests', to: 'EventRequestListPage' }
      ]
      advances: [
        { name: 'Coming soon +++', to: 'AdvanceListPage' }
      ]
      marketplace: [
        { name: 'Scanners +++', to: 'ScannerListPage' }
        { name: 'Space Types +++', to: 'SpaceListPage' }
        { name: 'Variables', to: 'VariablesListPage' }
        { name: 'Options +++', to: '' }
        { name: 'Universities', to: 'UniversityListPage' }
        { name: 'Hidden Brands', to: 'SecretBrandListPage' }
      ]
      system: [
        { name: 'Super Users', to: 'SuperUserListPage' }
        { name: 'Enabled Features', to: 'EnabledFeaturesListPage' }
        { name: 'Csv Export', to: 'CsvExportPage' }
        { name: 'Csv Import', to: 'CsvImportPage' }
        { name: 'Reporting Service', to: 'ReportingServicePage' }
      ]
      devTools: [
        { name: 'Dev Stats', to: 'DevStatsPage' }
        { name: 'Data Integrity', to: 'DataIntegrityPage' }
      ]

      opened: [1, 2]
  computed:
    sidekiqUrl: ->
      return "#{process.env.VUE_APP_API_ENDPOINT || ""}/sidekiq"

  methods:
    isActiveRoute: (name) ->
      @clearRouteName(name) == @clearRouteName(@$route.name)

    openSubMenu: (id) ->
      if @opened.includes id
        @opened = @opened.filter((n) -> n isnt id)
        return
      @opened.push id

    clearRouteName: (name) ->
      name.replace(/(ListPage|ShowPage|CreatePage|EditPage)/g, '')

    jsClassForMenu: (item) -> "js-#{item.name.toLowerCase().replace(/ /g, '')}-sidebar"
